<template>
    <el-dialog
        class="detail"
        :visible.sync="shippingMehtodVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="900px"
        title="Shipping"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <template v-if="!isBatch">
                <div class="order-detail-header">
                    <p class="order-num">Order #{{ orderDetail.plt_order_sn }}</p>
                    <!-- <p class="order-state"><i class="el-icon-s-help"></i>{{ orderDetail.status_name }}</p> -->
                    <!-- <p class="order-date">Order Date: {{ orderDetail.created_at }}</p> -->
                </div>
                <div class="order-detail-body">
                    <div class="order-detail-body-item">
                        <!-- <div class="order-detail-body-title">Order Information</div> -->
                        <div class="order-detail-body-label">
                            Shipping Address
                        </div>
                        <div class="order-detail-body-value">
                            {{ orderDetail.orders_address.buyer_name }}
                        </div>
                        <div class="order-detail-body-value">
                            {{
                                orderDetail.orders_address.street1 +
                                orderDetail.orders_address.street2
                            }}
                        </div>
                        <div class="order-detail-body-value">
                            {{
                                orderDetail.orders_address.city +
                                " " +
                                orderDetail.orders_address.state +
                                " " +
                                orderDetail.orders_address.postal_code
                            }}
                        </div>
                        <div class="order-detail-body-value">
                            {{ orderDetail.country }}
                        </div>
                        <div class="order-detail-body-value">
                            {{ orderDetail.orders_address.phone }}
                        </div>
                        <template v-if="orderDetail.last_mile">
                            <div class="order-detail-body-label">
                                Shipping Method
                            </div>
                            <div class="order-detail-body-value">
                                {{ orderDetail.last_mile }}
                            </div>
                        </template>
                        <template v-if="orderDetail.remark">
                            <div class="order-detail-body-label">Remark</div>
                            <div class="order-detail-body-value">
                                {{ orderDetail.remark }}
                            </div>
                        </template>
                    </div>
                </div>
            </template>
            <!-- <template v-if="shippingMethodList.length > 0"> -->
            <div class="shipping-tipbar">Shipping Methods</div>
            <div
                class="shipping-methods"
                :class="{ error: shippingMethodIsRequired }"
            >
                <div
                    class="shipping-methods-item"
                    v-for="item of shippingMethodList"
                    :key="item.id"
                >
                    <el-radio
                        v-model="channelCode"
                        :label="item.last_mile && item.last_mile.last_mile || ''"
                        @change="channelCodeChange(item)"
                    >
                        <span class="shipping-methods-price">{{
                            item.currency.symbol + item.price
                        }}</span>
                        <span class="shipping-methods-channel-name">{{
                            item.last_mile && item.last_mile.last_mile || ''
                        }}</span>
                        <span>{{ item.delivery }}</span>
                    </el-radio>
                </div>
            </div>
            <!-- </template> -->
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save" :disabled="disabled"
                >Save</el-button
            >
            <el-button size="small" @click="closeDialog">Close</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            orderDetail: {
                orders_address: {},
                orders_goods: [],
            },
            channelCode: "",
            act_ship_cost: "",
            shippingMethodList: [],
            shippingMethodIsRequired: false,
            disabled: false
        };
    },
    methods: {
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (/* columnIndex == 1 ||  */ columnIndex == 4) {
                return { color: "#9b3c44" };
            }
        },
        closeDialog() {
            this.shippingMethodList = [];
            this.$emit("update:shippingMehtodVisible", false);
        },
        getOrderDetail() {
            cmofferApi.orders({}, "get", this.tableItem.id).then((res) => {
                if (res) {
                    this.orderDetail = res.data;
                    this.channelCode = this.orderDetail.last_mile;
                    this.getShippingMethod();
                }
            });
        },
        getShippingMethod() {
            this.disabled = true;
            cmofferApi
                .shippingMethod({
                    country_id: this.orderDetail.country_id,
                    weight: this.orderDetail.weight,
                })
                .then((res) => {
                    this.disabled = false;
                    if (res) {
                        this.shippingMethodList = res.data;
                    }
                    this.channelCode = '';
                });
        },
        channelCodeChange(val) {
            this.shippingMethodIsRequired = false;
            this.act_ship_cost = val.price;
        },
        save() {
            if (!this.channelCode) {
                this.shippingMethodIsRequired = true;
                return;
            }
            cmofferApi
                .updateShipping(
                    {
                        id: this.orderDetail.id,
                        act_ship_cost: this.act_ship_cost,
                        last_mile: this.channelCode,
                    },
                    "post"
                )
                .then((res) => {
                    if (res && res.errcode === 0) {
                        this.$message.success(
                            `${this.$i18n.locale == "zh" ? "成功" : "Success"}`
                        );
                        this.closeDialog();
                        this.$parent.getOrdersList &&
                            this.$parent.getOrdersList();
                    }
                });
        },
        updateShipping() {
        },
    },
    props: {
        shippingMehtodVisible: Boolean,
        isBatch: Boolean,
        tableItem: Object,
    },
    watch: {
        shippingMehtodVisible() {
            if (this.shippingMehtodVisible) {
                this.getOrderDetail();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.container {
    .order-detail-header {
        display: flex;
        align-items: center;
        font-size: 14px;
        margin: 30px 0;
        padding-left: 10px;
        .order-num {
            font-size: 26px;
        }
        .print-order {
            color: $color-danger;
            margin: 0 30px;
        }
        .order-state {
            color: $color-danger;
            margin: 0 30px;
        }
        .order-date {
            color: $color-333333;
        }
    }
    .order-detail-body {
        border: 1px solid #d8d8d8;
        padding: 25px 35px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        .order-detail-body-item {
            &:not(:only-child) {
                max-width: 40%;
            }
        }
        .order-detail-body-title {
            font-size: 17px;
            font-weight: bold;
            margin-bottom: 20px;
        }
        .order-detail-body-label {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 10px;
        }
        .order-detail-body-value {
            font-size: 13px;
            margin-bottom: 8px;
            line-height: 20px;
        }

        .order-detail-body-value + .order-detail-body-label {
            margin-top: 20px;
        }
    }
    .shipping-tipbar {
        background-color: #f3f3f3;
        padding: 8px 20px;
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        line-height: 26px;
        font-size: 13px;
        color: $color-333333;
        margin: 20px 0;
        a {
            font-weight: 800;
        }
        i {
            font-weight: 600;
            font-size: 12px;
            margin-left: 5px;
        }
    }
    .shipping-methods {
        display: table;
        flex-wrap: wrap;
        padding: 5px;
        border: 1px solid transparent;
        .shipping-methods-item {
            .shipping-methods-price {
                min-width: 80px;
                display: inline-block;
                text-align: center;
            }
            .shipping-methods-channel-name {
                font-weight: 600;
                margin: 0 25px;
            }
            &:not(:last-child) {
                margin-bottom: 15px;
            }
        }
    }
}
</style>
